import { useNavigate } from "react-router-dom";

import Button from "components/Button";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

export const GeneralError = () => {
  const navigate = useNavigate();
  const { t } = useClientTranslation();

  usePageTracking({ name: "Error - view", properties: { type: "API page load" } });

  return (
    <PageLayout
      title={t("error.api_load.header")}
      bottomButtons={<Button onClick={() => navigate(-1)}>Go back</Button>}
    >
      <Text sizeVariant="md" mt={24} mx={24}>
        {t("error.api_load.instruction")}
      </Text>
    </PageLayout>
  );
};
